// extracted by mini-css-extract-plugin
export default {"initials":"AvatarInitials_initials__CtvRo"};